import { render, staticRenderFns } from "./vrste-odrzavanja.editor.vue?vue&type=template&id=58a5749c&scoped=true&"
import script from "./vrste-odrzavanja.editor.vue?vue&type=script&lang=ts&"
export * from "./vrste-odrzavanja.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5749c",
  null
  
)

export default component.exports